<template>
  <v-toolbar 
    v-if="needUpdate"
    dark 
    color="warning"
    class="mb-3"
    @click="refresh">
    <v-icon>refresh</v-icon>
    <span class="pl-2">
      {{ $t('general.messages.newVersion') }}
    </span>
    <v-spacer/>
  </v-toolbar>
</template>
<script>
import { mapState } from 'vuex'

export default {
  components: {},
  computed: {
    ...mapState({
      version: state => state.configuration.version,
      needUpdate: state => state.configuration.needUpdate,
    }),
  },
  watch: {},
  created() {
    this.init()
  },
  methods: {
    init() {
      this.$store.dispatch(`configuration/init`, {})
    },
    refresh() {
      location.reload()
    },
  },
}
</script>

<style lang="scss">

</style>
